import { SUB_OBJECT } from '../constants/subs';

export const subsGenerator = (count = 20) => [...Array(count)].map((_, i) => `sub${i + 1}`);

export const subsPresetsGenerator = (count = 20) => [...Array(count)]
  .map(() => ({ ...SUB_OBJECT }));
